import {
  button_group_default
} from "./chunk.HBRRBJJN.js";
import {
  size_default
} from "./chunk.SI24X5IH.js";
import {
  variants_default
} from "./chunk.7OG3CMFN.js";
import {
  WebAwesomeElement,
  e,
  n,
  r,
  t
} from "./chunk.LVUMIIKQ.js";
import {
  ke
} from "./chunk.S3625EU6.js";
import {
  __decorateClass
} from "./chunk.SZE6ONST.js";

// src/components/button-group/button-group.css
var button_group_default2 = ":host {\n  display: inline-flex;\n}\n";

// src/components/button-group/button-group.ts
var WaButtonGroup = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.disableRole = false;
    this.label = "";
    this.orientation = "horizontal";
    this.size = "inherit";
    this.variant = "inherit";
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("orientation")) {
      this.setAttribute("aria-orientation", this.orientation);
      this.updateClassNames();
    }
  }
  handleFocus(event) {
    const button = findButton(event.target);
    button?.classList.add("button--focus");
  }
  handleBlur(event) {
    const button = findButton(event.target);
    button?.classList.remove("button--focus");
  }
  handleMouseOver(event) {
    const button = findButton(event.target);
    button?.classList.add("button--hover");
  }
  handleMouseOut(event) {
    const button = findButton(event.target);
    button?.classList.remove("button--hover");
  }
  handleSlotChange() {
    this.updateClassNames();
  }
  updateClassNames() {
    const slottedElements = [...this.defaultSlot.assignedElements({ flatten: true })];
    slottedElements.forEach((el) => {
      const index = slottedElements.indexOf(el);
      const button = findButton(el);
      if (button) {
        button.classList.add("button");
        button.classList.toggle("wa-button-group-horizontal", this.orientation === "horizontal");
        button.classList.toggle("wa-button-group-vertical", this.orientation === "vertical");
        button.classList.toggle("button--first", index === 0);
        button.classList.toggle("button--inner", index > 0 && index < slottedElements.length - 1);
        button.classList.toggle("button--last", index === slottedElements.length - 1);
        button.classList.toggle("button--radio", button.tagName.toLowerCase() === "wa-radio-button");
      }
    });
  }
  render() {
    return ke`
      <slot
        part="base"
        class="wa-button-group"
        role="${this.disableRole ? "presentation" : "group"}"
        aria-label=${this.label}
        aria-orientation=${this.orientation}
        @focusout=${this.handleBlur}
        @focusin=${this.handleFocus}
        @mouseover=${this.handleMouseOver}
        @mouseout=${this.handleMouseOut}
        @slotchange=${this.handleSlotChange}
      ></slot>
    `;
  }
};
WaButtonGroup.shadowStyle = [size_default, variants_default, button_group_default, button_group_default2];
__decorateClass([
  e("slot")
], WaButtonGroup.prototype, "defaultSlot", 2);
__decorateClass([
  r()
], WaButtonGroup.prototype, "disableRole", 2);
__decorateClass([
  n()
], WaButtonGroup.prototype, "label", 2);
__decorateClass([
  n({ reflect: true })
], WaButtonGroup.prototype, "orientation", 2);
__decorateClass([
  n({ reflect: true, initial: "medium" })
], WaButtonGroup.prototype, "size", 2);
__decorateClass([
  n({ reflect: true, initial: "neutral" })
], WaButtonGroup.prototype, "variant", 2);
WaButtonGroup = __decorateClass([
  t("wa-button-group")
], WaButtonGroup);
function findButton(el) {
  const selector = "wa-button, wa-radio-button";
  return el.closest(selector) ?? el.querySelector(selector);
}

export {
  WaButtonGroup
};
